import * as UI from "@iyk/ui"
import * as React from "react"

export const Card = ({
  children,
  className,
  padding,
  rounded
}: {
  children: React.ReactNode
  className?: string
  padding: "none" | "sm" | "md"
  rounded: "base" | "md"
}) => {
  return <div className={classForCard({ className, rounded, padding })}>{children}</div>
}

export const classForCard = UI.cva(
  [
    "overflow-hidden relative",
    "bg-grayA-2 backdrop-blur-[10px]",
    "after:content-[''] after:absolute after:inset-0 after:z-10 after:bshadow after:bshadow-grayA-3 after:pointer-events-none"
  ],
  {
    variants: {
      rounded: {
        base: "rounded after:rounded",
        md: "rounded-md after:rounded-md"
      },
      padding: {
        none: "",
        sm: "p-3",
        md: "p-4",
        lg: "px-4 py-3"
      }
    }
  }
)
